import { useEffect, useState } from "react";

import AdminPage from "./components/AdminPage";
import AdminCard from "./components/AdminCard";
import AdminLoading from "./components/AdminLoading";

import AlgorithmModuleCard from "./components/AlgorithmModuleCard";

import {
    getAlgorithmPresets,
    getAlgorithmPreset,
    updateAlgorithmPreset,
    activateAlgorithmPreset,
    createAlgorithmPreset,
    deleteAlgorithmPreset,
    getAvailableModules,
    addAlgorithmModule,
    getAvailableFilters,
    deleteAlgorithmModule,
    getAvailableAlgorithmModules
} from "./api/algorithmApi";

export default function Algorithm() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activating, setActivating] = useState(false);

  const [presets, setPresets] = useState([]);
  const [selectedPreset, setSelectedPreset] = useState(null);

  const [modules, setModules] = useState([]);
  const [filters, setFilters] = useState([]);

  const [showCreate, setShowCreate] = useState(false);

  const [newPreset, setNewPreset] = useState({
    name: "",
    description: "",
    copyFromPresetId: "",
  });

  const [availableModules, setAvailableModules] = useState([]);
  const [showAddModule, setShowAddModule] = useState(false);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [selectedModuleName, setSelectedModuleName] = useState("");

  const [availableFilters, setAvailableFilters] = useState([]);
  const [showAddFilter, setShowAddFilter] = useState(false);

  useEffect(() => {
    loadPresets();
    loadAvailableFilters();
    loadAvailableModules();
  }, []);

  async function loadPresets(selectId = null) {
    try {
        setLoading(true);

        const data = await getAlgorithmPresets();

        console.log("Algorithm presets list:", data);

        setPresets(data);

        let preset;

        if(selectId){
            preset = data.find(
                item => item.id === Number(selectId)
            );
        }

        if(!preset){
            preset = data.find(
                item => item.active
            ) || data[0];
        }

        if(preset){
            await loadPreset(preset.id);
        }

    } catch(error){
        console.error(error);
    } finally {
        setLoading(false);
    }
  }

  async function loadPreset(id){

    try {

        const data = await getAlgorithmPreset(id);

        console.log("Algorithm preset detail:", data);

        setSelectedPreset(data.preset);

        setModules(data.modules || []);

        setFilters(data.filters || []);

    } catch(error){

        console.error(
            "Loading algorithm preset failed:",
            error
        );

    }
  }

  async function loadAvailableModules(){

      try {

          const modules =
              await getAvailableAlgorithmModules();

          setAvailableModules(modules);

      } catch(error){

          console.error(
              "Loading available modules failed:",
              error
          );

      }

  }

  async function handlePresetChange(e) {
    await loadPreset(
      Number(e.target.value),
    );
  }

  function updateFilter(index, field, value) {
    setFilters((prev) => {
      const copy = [...prev];

      copy[index] = {
        ...copy[index],
        [field]: value,
      };

      return copy;
    });
  }

  function removeFilter(index){

      setFilters(prev =>
          prev.filter(
              (_, i) => i !== index
          )
      );

  }

  async function save() {
    if (!selectedPreset) {
      return;
    }

    try {
      setSaving(true);

      await updateAlgorithmPreset(
        selectedPreset.id,
        {
          modules,
          filters,
        },
      );

      alert("Algorithm saved.");

      await loadPreset(
        selectedPreset.id,
      );
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Save failed.",
      );
    } finally {
      setSaving(false);
    }
  }

  async function activate() {
    if (!selectedPreset) {
      return;
    }

    try {
      setActivating(true);

      await activateAlgorithmPreset(
        selectedPreset.id,
      );

      await loadPresets(
        selectedPreset.id,
      );

      alert("Preset activated.");
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Activation failed.",
      );
    } finally {
      setActivating(false);
    }
  }

  async function handleCreatePreset() {
    if (!newPreset.name.trim()) {
      alert("Preset name is required.");
      return;
    }

    try {
      const result =
        await createAlgorithmPreset({
          name: newPreset.name,
          description:
            newPreset.description,
          copyFromPresetId:
            newPreset.copyFromPresetId ||
            null,
        });

      setShowCreate(false);

      setNewPreset({
        name: "",
        description: "",
        copyFromPresetId: "",
      });

      await loadPresets(result.id);
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Unable to create preset.",
      );
    }
  }

  async function handleDuplicatePreset() {
    if (!selectedPreset) {
      return;
    }

    const name = prompt(
      "Name for the duplicated preset:",
      `${selectedPreset.name} Copy`,
    );

    if (!name) {
      return;
    }

    try {
      const result =
        await createAlgorithmPreset({
          name,
          description:
            selectedPreset.description,
          copyFromPresetId:
            selectedPreset.id,
        });

      await loadPresets(result.id);
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Unable to duplicate preset.",
      );
    }
  }

  async function handleDeletePreset() {
    if (!selectedPreset) {
      return;
    }

    if (selectedPreset.active) {
      alert(
        "You cannot delete the active preset.",
      );
      return;
    }

    const confirmed =
      window.confirm(
        `Delete '${selectedPreset.name}'?`,
      );

    if (!confirmed) {
      return;
    }

    try {
      await deleteAlgorithmPreset(
        selectedPreset.id,
      );

      await loadPresets();
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Unable to delete preset.",
      );
    }
  }

  // function addModule() {
  //   setModules(prev => [
  //     ...prev,
  //     {
  //       id: `new-${Date.now()}`,
  //       module_name: "",
  //       weight: 0,
  //       enabled: 1,
  //       settings: {}
  //     }
  //   ]);
  // }

  async function openAddModule() {

      try {

          const available =
              await getAvailableModules();

          const filtered =
              available.filter(module =>
                  !modules.some(
                      current =>
                          current.module_name === module.module_name
                  )
              );

          setAvailableModules(filtered);

          setSelectedModuleName(
              filtered[0]?.module_name || ""
          );

          setShowAddModule(true);

      } catch(error) {

          console.error(
              "Loading available modules failed:",
              error
          );

      }
  }

  function addModule(moduleDefinition){

    const exists =
        modules.some(
            module =>
                module.module_name ===
                moduleDefinition.module_name
        );

    if(exists){
        return;
    }


    const newModule = {

        id: Date.now(),

        module_name:
            moduleDefinition.module_name,

        weight:
            moduleDefinition.defaultWeight,

        enabled:1,

        settings:
            {
                ...moduleDefinition.defaultSettings
            },

        settingsSchema:
            moduleDefinition.settingsSchema

    };


    setModules(prev => [
        ...prev,
        newModule
    ]);


    setShowModuleModal(false);
  }

  async function handleAddModule() {

      try {

          await addAlgorithmModule(
              selectedPreset.id,
              selectedModuleName
          );

          setShowAddModule(false);

          await loadPreset(
              selectedPreset.id
          );

      } catch(error) {

          console.error(
              "Adding module failed:",
              error
          );

          alert(
              error.response?.data?.error ||
              "Unable to add module"
          );

      }
  }

  async function removeModule(moduleId){

      try {

          await deleteAlgorithmModule(
              selectedPreset.id,
              moduleId
          );

          setModules(prev =>
              prev.filter(
                  module => module.id !== moduleId
              )
          );

      } catch(error){

          console.error(error);

          alert(
              error.response?.data?.message ||
              "Unable to delete module"
          );

      }
  }

  async function loadAvailableFilters(){

      try {

          const data =
              await getAvailableFilters();

          setAvailableFilters(data);

      } catch(error){

          console.error(
              "Loading available filters failed:",
              error
          );

      }
  }

  function addFilter(filter){

      const exists =
          filters.some(
              item =>
              item.market === filter.market
          );


      if(exists){

          alert(
              "Filter already exists"
          );

          return;
      }


      setFilters(prev => [

          ...prev,

          {
              id:null,
              market:filter.market,
              operator:filter.operator,
              value:filter.defaultValue,
              enabled:1
          }

      ]);


      setShowAddFilter(false);

  }

  if (loading) {
      return (
        <AdminPage
          title='Prediction Settings'
          subtitle='Manage prediction presets.'
        >
          <AdminLoading />
        </AdminPage>
      );
    }

  return (
    <AdminPage
      title="Algorithm"
      subtitle="Manage prediction algorithm configuration"
    >
      <AdminCard className="p-6 max-w-5xl">

        <div className="flex justify-between gap-4 mb-6">

          <select
            value={selectedPreset?.id || ""}
            onChange={handlePresetChange}
            className="
              flex-1
              bg-gray-800
              border
              border-gray-700
              rounded-xl
              px-4
              py-3
              text-white
            "
          >
            {presets.map((preset) => (
              <option
                key={preset.id}
                value={preset.id}
              >
                {preset.name}
                {preset.active ? " (Active)" : ""}
              </option>
            ))}
          </select>

          <button
            onClick={() => setShowCreate(true)}
            className="
              px-5
              py-3
              rounded-xl
              bg-blue-600
              hover:bg-blue-500
              font-bold
            "
          >
            + New Preset
          </button>

          <button
            onClick={handleDuplicatePreset}
            disabled={!selectedPreset}
            className="
              px-5
              py-3
              rounded-xl
              bg-purple-600
              hover:bg-purple-500
              font-bold
              disabled:opacity-40
            "
          >
            Duplicate
          </button>

          <button
            onClick={handleDeletePreset}
            disabled={!selectedPreset || selectedPreset.active}
            className="
              px-5
              py-3
              rounded-xl
              bg-red-600
              hover:bg-red-500
              font-bold
              disabled:opacity-40
            "
          >
            Delete
          </button>

        </div>

        {selectedPreset && (
          <div
            className="
              mb-8
              bg-black/30
              border
              border-green-500/20
              rounded-xl
              p-5
            "
          >
            <h3 className="text-green-300 font-bold text-lg">
              {selectedPreset.name}
            </h3>

            <p className="text-gray-400 text-sm">
              {selectedPreset.description || "No description"}
            </p>
          </div>
        )}

        <div className="mb-10">

          <div className="flex justify-between items-center mb-4">

            <h2 className="text-xl font-bold text-green-300">
              Modules
            </h2>

            <button
              onClick={() => setShowModuleModal(true)}
              className="
                  px-4
                  py-3
                  rounded-xl
                  bg-blue-600
                  hover:bg-blue-500
                  font-bold
              "
            >
              + Add Module
          </button>

          </div>

          {modules.map((module, index) => (
            <AlgorithmModuleCard
              key={module.id}
              module={module}
              onChange={(updated)=>{
                  setModules(prev =>
                      prev.map((m,i)=>
                          i===index
                          ? updated
                          : m
                      )
                  );
              }}
              onDelete={() =>
                  removeModule(module.id)
              }
            />
          ))}

        </div>

        <div>

          <div className="flex justify-between items-center">

          <h2 className='text-xl font-bold text-green-300'>
              Filters
          </h2>


          <button
              onClick={() => setShowAddFilter(true)}
              className="
                  px-4
                  py-2
                  rounded-xl
                  bg-blue-600
                  hover:bg-blue-500
                  font-bold
              "
          >
              + Add Filter
          </button>

          </div>


          {filters.map((filter,index)=>(

          <div
              key={index}
              className="
                  flex
                  gap-3
                  mt-4
                  items-center
              "
          >

          <input
              value={filter.market}
              disabled
              className="
                  flex-1
                  bg-gray-800
                  rounded-lg
                  px-3
                  py-2
              "
          />


          <input
              value={filter.operator}
              disabled
              className="
                  w-20
                  bg-gray-800
                  rounded-lg
                  px-3
                  py-2
              "
          />


          <input
              type="number"
              value={filter.value}
              onChange={(e)=>
                  updateFilter(
                      index,
                      "value",
                      Number(e.target.value)
                  )
              }
              className="
                  w-24
                  bg-gray-800
                  rounded-lg
                  px-3
                  py-2
              "
          />


          <label className="text-gray-400">

          <input
              type="checkbox"
              checked={filter.enabled === 1}
              onChange={(e)=>
                  updateFilter(
                      index,
                      "enabled",
                      e.target.checked ? 1 : 0
                  )
              }
          />

          Enabled

          </label>

          <button
              onClick={() => removeFilter(index)}
              className="
                  px-2
                  py-1
                  rounded-lg
                  bg-red-600
                  hover:bg-red-500
                  font-bold
              "
          >
              X
          </button>


          </div>

          ))}


          </div>

        <div className="flex justify-end gap-3 mt-10">

          <button
            onClick={activate}
            disabled={activating || selectedPreset?.active}
            className="
              px-5
              py-3
              rounded-xl
              bg-purple-600
              hover:bg-purple-500
              font-bold
              disabled:opacity-40
            "
          >
            {activating
              ? "Activating..."
              : selectedPreset?.active
                ? "Active"
                : "Activate"}
          </button>

          <button
            onClick={save}
            disabled={saving}
            className="
              px-5
              py-3
              rounded-xl
              bg-green-600
              hover:bg-green-500
              font-bold
              disabled:opacity-40
            "
          >
            {saving
              ? "Saving..."
              : "Save Changes"}
          </button>

        </div>

      </AdminCard>

      {showCreate && (
        <div
          className="
            fixed
            inset-0
            bg-black/70
            flex
            items-center
            justify-center
            z-50
          "
        >
          <div
            className="
              w-full
              max-w-md
              bg-gray-900
              border
              border-gray-700
              rounded-xl
              p-6
            "
          >

            <h3 className="text-xl font-bold text-green-300 mb-5">
              Create Algorithm Preset
            </h3>

            <input
              placeholder="Preset name"
              value={newPreset.name}
              onChange={(e) =>
                setNewPreset((prev) => ({
                  ...prev,
                  name: e.target.value
                }))
              }
              className="
                w-full
                mb-3
                bg-gray-800
                rounded-lg
                px-4
                py-3
              "
            />

            <input
              placeholder="Description"
              value={newPreset.description}
              onChange={(e) =>
                setNewPreset((prev) => ({
                  ...prev,
                  description: e.target.value
                }))
              }
              className="
                w-full
                mb-3
                bg-gray-800
                rounded-lg
                px-4
                py-3
              "
            />

            <select
              value={newPreset.copyFromPresetId}
              onChange={(e) =>
                setNewPreset((prev) => ({
                  ...prev,
                  copyFromPresetId: e.target.value
                }))
              }
              className="
                w-full
                mb-5
                bg-gray-800
                rounded-lg
                px-4
                py-3
              "
            >
              <option value="">
                Start empty
              </option>

              {presets.map((preset) => (
                <option
                  key={preset.id}
                  value={preset.id}
                >
                  Copy from {preset.name}
                </option>
              ))}
            </select>

            <div className="flex justify-end gap-3">

              <button
                onClick={() => setShowCreate(false)}
                className="
                  px-4
                  py-3
                  rounded-xl
                  bg-gray-700
                "
              >
                Cancel
              </button>

              <button
                onClick={handleCreatePreset}
                className="
                  px-4
                  py-3
                  rounded-xl
                  bg-green-600
                  font-bold
                "
              >
                Create
              </button>

            </div>

          </div>
        </div>
      )}

      {showModuleModal && (

        <div
            className="
                fixed
                inset-0
                bg-black/70
                flex
                items-center
                justify-center
                z-50
            "
        >

            <div
                className="
                    bg-gray-900
                    border
                    border-gray-700
                    rounded-xl
                    p-6
                    w-full
                    max-w-lg
                "
            >

                <h2
                    className="
                        text-xl
                        font-bold
                        text-green-300
                        mb-5
                    "
                >
                    Add Algorithm Module
                </h2>


                {availableModules
                    .filter(moduleDefinition =>

                        !modules.some(
                            module =>
                            module.module_name ===
                            moduleDefinition.module_name
                        )

                    )
                    .map(moduleDefinition => (

                    <div
                        key={moduleDefinition.module_name}
                        className="
                            bg-black/30
                            border
                            border-green-500/20
                            rounded-xl
                            p-4
                            mb-3
                        "
                    >

                        <h3
                            className="
                                text-white
                                font-bold
                            "
                        >
                            {moduleDefinition.label}
                        </h3>


                        <p
                            className="
                                text-gray-400
                                text-sm
                                mb-3
                            "
                        >
                            {moduleDefinition.description}
                        </p>


                        <button
                            onClick={() =>
                                addModule(moduleDefinition)
                            }
                            className="
                                px-4
                                py-2
                                rounded-lg
                                bg-green-600
                                hover:bg-green-500
                                font-bold
                            "
                        >
                            Add
                        </button>

                    </div>

                ))}


                <button
                    onClick={() =>
                        setShowModuleModal(false)
                    }
                    className="
                        mt-3
                        px-4
                        py-2
                        rounded-lg
                        bg-gray-700
                    "
                >
                    Cancel
                </button>


            </div>

        </div>

        )}

      {showAddFilter && (

        <div
        className="
        fixed
        inset-0
        bg-black/70
        flex
        items-center
        justify-center
        z-50
        "
        >

        <div
        className="
        bg-gray-900
        border
        border-gray-700
        rounded-xl
        p-6
        w-full
        max-w-md
        "
        >

        <h3 className="
        text-xl
        text-green-300
        font-bold
        mb-5
        ">
        Add Filter
        </h3>


        {availableFilters.map(filter => (

        <button
        key={filter.market}
        onClick={() => addFilter(filter)}
        className="
        block
        w-full
        text-left
        bg-gray-800
        hover:bg-gray-700
        rounded-lg
        px-4
        py-3
        mb-3
        "
        >

        {filter.market}
        &nbsp;
        {filter.operator}
        &nbsp;
        {filter.defaultValue}

        </button>

        ))}


        <button
        onClick={() => setShowAddFilter(false)}
        className="
        w-full
        mt-3
        px-4
        py-3
        rounded-lg
        bg-gray-700
        "
        >
        Cancel
        </button>


        </div>

        </div>

        )}

    </AdminPage>
  );
}